<template>
	<div class="container-fluid content">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ $t('Mi selección') }}</h4>
        
        <pasos-compra></pasos-compra>  

        <br><br><br> 

        <seleccion 
          tipo="cine"
          :type.sync="modalType"
          :productID.sync="modalProductID"
          :show.sync="showModalFichaExtendida">
        </seleccion>

        <seleccion 
          tipo="musica"
          :type.sync="modalType"
          :productID.sync="modalProductID"
          :show.sync="showModalFichaExtendida">
        </seleccion>

        <seleccion 
          tipo="infantil"
          :type.sync="modalType"
          :productID.sync="modalProductID"
          :show.sync="showModalFichaExtendida">
        </seleccion>

        <seleccion 
          tipo="libros"
          :type.sync="modalType"
          :productID.sync="modalProductID"
          :show.sync="showModalFichaExtendida">
        </seleccion>

        <seleccion 
          tipo="series"
          :type.sync="modalType"
          :productID.sync="modalProductID"
          :show.sync="showModalFichaExtendida">
        </seleccion>

        <seleccion 
          tipo="documentales"
          :type.sync="modalType"
          :productID.sync="modalProductID"
          :show.sync="showModalFichaExtendida">
        </seleccion>

        <seleccion-totales></seleccion-totales>

        <modal-ficha-extendida 
          :show.sync="showModalFichaExtendida"
          :type="modalType"
          :productID="modalProductID"
          :miSeleccion="true">
        </modal-ficha-extendida>

      </div>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Mi selección": "Mi selección"
  },
  "en": {
  },
  "ca": {
    "Mi selección": "La meva selecció"
  }
}
</i18n>

<script>
  import axios from 'axios';

  import UsuarioEditarPerfil from './UsuarioEditarPerfil.vue';
  import UsuarioCambiarContrasena from './UsuarioCambiarContrasena.vue';
  import PasosCompra from './usuario/PasosCompra.vue';
  import Seleccion from './usuario/Seleccion.vue';
  import SeleccionTotales from './usuario/SeleccionTotales.vue';
  import ModalFichaExtendida from './ModalFichaExtendida.vue';

  import { mapGetters, mapMutations } from 'vuex';

	export default {
    components: { UsuarioEditarPerfil, UsuarioCambiarContrasena, PasosCompra, Seleccion, SeleccionTotales, ModalFichaExtendida},
    data: () => {
      return {
        showModalFichaExtendida: false,
        modalType: "",
        modalProductID: 0,
      }
    },
    created(){
      this.setPasoCompra(1);
      this.getMiSeleccion();
    },
    mounted(){
    },
    updated(){
    },
    computed: {
      ...mapGetters(['getLocale', 'getApiUrl']),
    },
    methods:{
      ...mapMutations(['setPasoCompra']),
      getMiSeleccion(){
        axios.get(this.getApiUrl + this.getLocale + '/miseleccion')
        //axios.get('src/json/mi-seleccion.json')
          .then( (respuesta) => {
            this.$store.commit('setMiSeleccion', respuesta.data.data );
          })
      }
    }
  }
</script>
